import sparseUndefined from './sparse-undefined.js';
import undf from '../types/undef.js';

const undef = [
    sparseUndefined,
    undf
];

export default undef;
